import * as tslib_1 from "tslib";
import { ShadowChunkBase } from "./ShadowChunkBase";
/**
 * ShadowHardChunk provides the cheapest shadow map method by using a single tap without any filtering.
 */
var ShadowHardChunk = (function (_super) {
    tslib_1.__extends(ShadowHardChunk, _super);
    /**
     * Creates a new ShadowHardChunk.
     */
    function ShadowHardChunk(method, shader) {
        return _super.call(this, method, shader) || this;
    }
    /**
     * @inheritDoc
     */
    ShadowHardChunk.prototype._getPlanarFragmentCode = function (targetReg, regCache, sharedRegisters) {
        var code = "";
        var decReg = regCache.getFreeFragmentConstant();
        regCache.getFreeFragmentConstant();
        var depthCol = regCache.getFreeFragmentVectorTemp();
        this._fragmentConstantsIndex = decReg.index * 4;
        code += this._depthMap._getFragmentCode(depthCol, regCache, sharedRegisters, this._depthMapCoordReg) +
            "dp4 " + depthCol + ".z, " + depthCol + ", " + decReg + "\n" +
            "slt " + targetReg + ".w, " + this._depthMapCoordReg + ".z, " + depthCol + ".z\n"; // 0 if in shadow
        return code;
    };
    /**
     * @inheritDoc
     */
    ShadowHardChunk.prototype._getPointFragmentCode = function (targetReg, regCache, sharedRegisters) {
        var code = "";
        var decReg = regCache.getFreeFragmentConstant();
        var epsReg = regCache.getFreeFragmentConstant();
        var posReg = regCache.getFreeFragmentConstant();
        var depthSampleCol = regCache.getFreeFragmentVectorTemp();
        regCache.addFragmentTempUsages(depthSampleCol, 1);
        var lightDir = regCache.getFreeFragmentVectorTemp();
        regCache.addFragmentTempUsages(lightDir, 1);
        this._fragmentConstantsIndex = decReg.index * 4;
        code += "sub " + lightDir + ", " + sharedRegisters.globalPositionVarying + ", " + posReg + "\n" +
            "dp3 " + lightDir + ".w, " + lightDir + ".xyz, " + lightDir + ".xyz\n" +
            "mul " + lightDir + ".w, " + lightDir + ".w, " + posReg + ".w\n" +
            "nrm " + lightDir + ".xyz, " + lightDir + ".xyz\n" +
            this._depthMap._getFragmentCode(depthSampleCol, regCache, sharedRegisters, lightDir) +
            "dp4 " + depthSampleCol + ".z, " + depthSampleCol + ", " + decReg + "\n" +
            "add " + targetReg + ".w, " + lightDir + ".w, " + epsReg + ".x\n" +
            "slt " + targetReg + ".w, " + targetReg + ".w, " + depthSampleCol + ".z\n"; // 0 if in shadow
        regCache.removeFragmentTempUsage(lightDir);
        regCache.removeFragmentTempUsage(depthSampleCol);
        return code;
    };
    /**
     * @inheritDoc
     */
    ShadowHardChunk.prototype._getCascadeFragmentCode = function (decodeRegister, depthProjection, targetRegister, registerCache, sharedRegisters) {
        var temp = registerCache.getFreeFragmentVectorTemp();
        return this._depthMap._getFragmentCode(temp, registerCache, sharedRegisters, depthProjection) +
            "dp4 " + temp + ".z, " + temp + ", " + decodeRegister + "\n" +
            "slt " + targetRegister + ".w, " + depthProjection + ".z, " + temp + ".z\n"; // 0 if in shadow
    };
    /**
     * @inheritDoc
     */
    ShadowHardChunk.prototype._activateForCascade = function () {
    };
    return ShadowHardChunk;
}(ShadowChunkBase));
export { ShadowHardChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/ShadowHardChunk.js